export default __webpack_public_path__ + "static/media/about_banner.fcbdcf87.jpg";